import CasesPage from "../../shared-pages/read-only/hospital-and-cases/CasesPage";
import "antd/dist/antd.css";

const MMRHospitalsCasePage = (props) => {
  const {
    match: { params },
  } = props;

  const { id: manufacturerId, hospitalid: hospitalId } = params;

  return (
    <CasesPage
      entity="area"
      entityId={manufacturerId}
      hospitalId={hospitalId}
    />
  );
};

export default MMRHospitalsCasePage;
